import "./Men.css"
import Product1 from "../Components/Product1"
import Men1 from "../images/m1.webp"
import Men2 from "../images/m2.jpg"
import Men3 from "../images/m3.jpg"
import Men4 from "../images/m4.jpg"
import Men5 from "../images/m5.webp"
import Men6 from "../images/m6.webp"
import Men7 from "../images/m7.jpg"
import Men8 from "../images/m8.jpg"
import Men9 from "../images/menadd.jpg"


export default function Men() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Men9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">
"
            <Product1  id="m1"  prdName="Beach Leafs" img={Men1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="m2" prdName="U.S POLO" img={Men2} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="m3" prdName="LEVIS" img={Men3} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="m4" prdName="CLASSIC POLO" img={Men4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="m5" prdName=" H & M " img={Men5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="m6" prdName="SECOND SKINN" img={Men6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="m7" prdName="GREEN WOOD" img={Men7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="m8" prdName="GREEN LAND" img={Men8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}